export const bot = {
    state: {
        botId: '',
        botTitle: '',
        allBots: []
    },
    getters: {
        'bot/id': state => state.botId,
        'bot/all': state => state.allBots
    },
    mutations: {
        'SET_BOT_ID' (state , botId){
            state.botId = botId
        },
        'SET_BOT_TITLE' (state, botTitle){
            state.botTitle = botTitle
        },
        SET_ALL_BOTS (state, bots) {
            state.allBots = bots
        }
    },
    actions: {
        setBotId({commit},botId){
            commit('SET_BOT_ID',botId)
        },
        setBotTitle({commit},botTitle){
            commit('SET_BOT_TITLE',botTitle)
        },
        setAllBots({commit}, allBots) {
            commit('SET_ALL_BOTS', allBots)
        }
    }
}
